import { render, staticRenderFns } from "./role_edit.vue?vue&type=template&id=17bca6bd&scoped=true"
import script from "./role_edit.vue?vue&type=script&lang=js"
export * from "./role_edit.vue?vue&type=script&lang=js"
import style0 from "./role_edit.vue?vue&type=style&index=0&id=17bca6bd&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17bca6bd",
  null
  
)

export default component.exports